import { call } from "redux-saga/effects";
import { APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* refreshCompanyRates(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.TAX.REFRESH_COMPANY_RATES, null, true);
}

export function* getRate(action: any): any {
    const { countryCode, zip } = action.payload;
    const url = `${APIS.TAX.GET_RATE}?countryCode=${countryCode}&zip=${zip}`;
    yield call(sagaFunction, action, CallApi.GET, url, null, true);
}

export function* rateBulk(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.TAX.RATE_BULK, action.payload, true);
}

export function* additionalTaxList(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.TAX.ADDITIONAL_TAX_LIST, action.payload, true);
}

export function* additionalTaxInsertUpdate(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.TAX.ADDITIONAL_TAX_INSERT_UPDATE, action.payload, true);
}

export function* additionalTaxDetails(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.TAX.ADDITIONAL_TAX_DETAILS + action.payload, null, true);
}

export function* additionalTaxDelete(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.TAX.ADDITIONAL_TAX_DELETE, action.payload, true);
}
